module.exports = __webpack_public_path__ + "img/TU.c744c879.png";